<template>
    <div>
        <GridColumnMenuCheckboxFilter :column="column" :filter="filter" :filterable="filterable" :unique-data="uniqueData"
            :search-box="false" :data-items="it" :expanded="true" @filterchange="filterChange" @expandchange="expandChange"
            @closemenu="closeMenu" />
    </div>
</template>
<script>
import { GridColumnMenuCheckboxFilter } from '@progress/kendo-vue-grid';

export default {
    props: {
        column: Object,
        filter: Object,
        filterable: Boolean,
        uniqueData: {
            type: Boolean,
            default: true
        },
        items: Array
    },
    data() {
        return {

        };
    },
    computed: {
        it() {
            return [
                {
                    productInfoFieldEn: "Disabled",
                    productInfoFieldTc: "已停用",
                    productInfoFieldSc: "已停用",
                },
                {
                    productInfoFieldEn: "Active",
                    productInfoFieldTc: "已上架",
                    productInfoFieldSc: "已上架",
                },
                {
                    productInfoFieldEn: "Offline",
                    productInfoFieldTc: "已下架",
                    productInfoFieldSc: "已下架",
                },
                {
                    productInfoFieldEn: "Unsubmitted",
                    productInfoFieldTc: "未提交",
                    productInfoFieldSc: "未提交",
                },
            ];
        }
    },
    components: {
        'GridColumnMenuCheckboxFilter': GridColumnMenuCheckboxFilter
    },
    methods: {
        expandChange() {
            this.$emit('expandchange');
        },
        closeMenu() {
            this.$emit('closemenu');
        },
        filterChange(newDescriptor, e) {
            this.$emit('filterchange', newDescriptor, e);
        }
    }
}
</script>